<template>
  <div>
    <info-mobile
      :info.sync="details.group_name"
      title="Course Name"
      id="group-name"
    />
    <info-mobile
      :info.sync="details.interface"
      title="Description"
      id="group-interface"
    />
    <info-mobile
      :info.sync="details.club_friendly_name"
      title="Club Friendly Name"
      id="group-name"
    />
    <info-mobile
      :info.sync="details.launch_mode"
      title="Launch Mode"
      id="group-interface"
      select
    />
    <info-mobile
      :info.sync="details.gpsi_server"
      title="GPSI Server"
      id="group-name"
      select
    />
    <info-mobile
      :info.sync="details.site_id"
      title="Site ID"
      id="group-interface"
    />
    <info-mobile
      :info.sync="details.vistar_direct"
      title="vistar_direct"
      id="group-vistar-direct"
      :cols="3"
      select
      vistar
      :items="vistarOptions"
    />
    <info-mobile
      :info.sync="details.address_1"
      title="Address"
      id="group-name"
    />
    <info-mobile
      :info.sync="details.address_2"
      title="Address 2"
      id="group-interface"
    />
    <info-mobile
      :info.sync="details.city"
      title="City"
      id="group-name"
    />
    <info-mobile
      :info.sync="details.state"
      title="State"
      id="group-interface"
      select
    />
    <info-mobile :info.sync="details.zip" title="Zip" id="group-name" />
    <info-mobile
      :info.sync="details.lat"
      title="Latitude"
      id="group-interface"
    />
    <info-mobile :info.sync="details.lng" title="Longitude" id="group-name" />
    <info-mobile :info.sync="email" title="Email" id="group-email" :cols="3" />
    <info-mobile :info.sync="phone" title="Phone" id="group-phone" phone :cols="3" />
  </div>
</template>
<script>
import InfoMobile from '@/components/group-details/InfoMobile';
import GroupDetailData from '@/mixins/GroupDetailData';

export default {
  components: {
    InfoMobile,
  },
  mixins: [GroupDetailData],
  data() {
    return {
      vistarOptions: [
        { text: 'No Vistar', value: 0 },
        { text: 'Vistar Normal', value: 1 },
        { text: 'Vistar Direct', value: 2 },
      ],
    };
  },
};
</script>
